import type { Environment } from './environment.interface';

const BACKEND_DOMAIN = 'http://dev.datanyze.com';
const ASSETS_DOMAIN = 'https://assets.datanyze.com';

export const environment: Environment = {
  production: false,
  name: 'dev',
  backend_domain: BACKEND_DOMAIN,
  website_url: `${BACKEND_DOMAIN}:4200/`,
  platform_url: `${BACKEND_DOMAIN}:4201/`,
  images_url: `${ASSETS_DOMAIN}/images`,
  icons_url: `${ASSETS_DOMAIN}/icons`,
  identity_backend_url: `${BACKEND_DOMAIN}:3003/identity`,
  payment_providers_backend_url: `${BACKEND_DOMAIN}:3006/payment-providers`,
  payment_backend_url: `${BACKEND_DOMAIN}:3006/payment`,
  config_backend_url: `${BACKEND_DOMAIN}:3001/config`,
  stripe_backend_url: `${BACKEND_DOMAIN}:3008/stripe`,
  GOOGLE_TAG_MANAGER_ID: 'GTM-MQCTMBN',
  SALESFORCE_CAMP_ID: {
    goTo_signup: '7014y000001t6UxAAI',
  },
  teamId: '',
  userId: '',
  email: '',
  auth_cookie: 'dn-tk-dev',
  deviceId_cookie: 'deviceId-dev',
  verification_id_cookie: 'dn-verification-id-dev',

  // Constants moved from ConstantsService
  DATANYZE_COOKIE_DOMAIN: '.datanyze.com',
  GOOGLE_ANALYTIC_SECTION: 'website',
  SF_CAMP_ID: 'camp_id',
  REDIRECT_KEY: 'redirect',
  SKIPCAPTCHA_KEY: 'skipcaptcha',
  GA_COOKIE_FETCH_RETRIES: 3,
  GTM_COOKIE_NAME: '_ga',
  GA_COOKIE_FETCH_INTERVAL: 2000,
  GOOGLE_OPTIMIZE_SCRIPT: 'https://www.googleoptimize.com/optimize.js?id=OPT-K5F7LKW',
  COOKIE_CONSENT_COOKIE_NAME: 'CookieConsent',
  RANDOM_ID_KEY: 'dev-user-session-id',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
